import { magic_effects } from './magic_effects';
import { standard_effects } from './standard_effects';

export const isMagicEffect = (effectId: string): boolean => {
    const allEffects = [...magic_effects, ...standard_effects];
    const effect = allEffects.find(e => e.id === effectId);
    return effect?.isMagic ?? false;
};